export default __webpack_public_path__ + "static/media/avatarA6.1b39170d.png";